module.exports = __webpack_public_path__ + "img/joinuser2.e440521a.jpg";